import { render } from "./matchTeam.vue?vue&type=template&id=5668f43d&scoped=true&ts=true"
import script from "./matchTeam.vue?vue&type=script&lang=ts"
export * from "./matchTeam.vue?vue&type=script&lang=ts"

import "./matchTeam.vue?vue&type=style&index=0&id=5668f43d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5668f43d"]])

export default __exports__